<div
  class="location-field-container"
  [class.compact]="compact()"
  #locationFieldContainer
>
  <mat-form-field
    appearance="outline"
    subscriptSizing="dynamic"
    class="location-field"
    [formGroup]="form"
  >
    <mat-label>Location</mat-label>
    <input
      #locationInput
      matInput
      class="location-name-form-input"
      [value]="$locationNameValue()"
      (blur)="$locationInputFocused.set(false)"
      (focus)="$locationInputFocused.set(true)"
      (input)="updateLocationName($event)"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      autoActiveFirstOption
      (optionSelected)="autocompleteOptionSelected($event)"
      [displayWith]="autocompleteDisplayFn"
    >
      @for (option of locationOptions(); track option) {
        <mat-option class="title-option" [value]="option">
          <span class="body-medium">{{
            option.placePrediction?.mainText?.text?.slice(
              0,
              option.placePrediction?.mainText?.matches?.[0]?.startOffset ?? 0
            )
          }}</span>
          <span class="body-medium match">{{
            option.placePrediction?.mainText?.text?.slice(
              option.placePrediction?.mainText?.matches?.[0]?.startOffset ?? 0,
              option.placePrediction?.mainText?.matches?.[0]?.endOffset ?? 0
            )
          }}</span>
          <span class="body-medium">{{
            option.placePrediction?.mainText?.text?.slice(
              option.placePrediction?.mainText?.matches?.[0]?.endOffset ?? 0
            )
          }}</span>
          <span class="label-small on-surface-variant-text">
            {{ option.placePrediction?.secondaryText?.text }}
          </span>
        </mat-option>
      }
    </mat-autocomplete>
    <button
      mat-icon-button
      matSuffix
      type="button"
      class="open-map-button"
      [class.compact]="compact()"
      [class.disabled]="
        form.controls.locationName.value.toLocaleLowerCase() === 'virtual'
      "
      (click)="openLocationDialog($event)"
      [disabled]="
        form.controls.locationName.value.toLocaleLowerCase() === 'virtual'
      "
    >
      <mat-icon class="primary-text fill">gps_fixed</mat-icon>
    </button>
  </mat-form-field>
</div>

@if (showMapPreview()) {
  @if (selectedLocation(); as location) {
    <hang-map
      [location]="location"
      [height]="compact() ? 100 : 200"
      [collapsed]="location.coords.lat === 0 && location.coords.lat === 0"
      [class.collapsed]="location.coords.lat === 0 && location.coords.lat === 0"
    ></hang-map>
  }
}

@if (selectedLocation(); as location) {
  <div class="on-surface-text label-small map-hint">
    {{ location.address }}
  </div>
}

<select-dialog #locationDialog (confirmed)="updateLocation($event)">
  <ng-template #lazyLoad>
    <select-location [location]="selectedLocation()"> </select-location>
  </ng-template>
</select-dialog>
